(function () {
    'use strict';

    angular.module("imApp").factory("oeeStateRemarksService", [function () {
        let service = {

        };

        return service;
    }]);
})();
